export default "__VITE_ASSET__DUcmdRjY__"